import React, { useState } from 'react';
import ContactButton from '../common/ContactButton';

const ArtPiece = ({ piece, onContactClick }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const handleInquire = () => {
        onContactClick("Art Commission", {
            message: `I'm interested in commissioning artwork similar to "${piece.title}". Please let me know about your process, timeline, and pricing.`,
            serviceDetails: `Commission inquiry for artwork similar to: ${piece.title}${piece.medium ? ` (${piece.medium})` : ''}${piece.dimensions ? ` - ${piece.dimensions}` : ''}`
        });
    };

    return (
        <div className="relative group mb-12">
            <div className="relative overflow-hidden rounded-lg shadow-lg">
                {!imageLoaded && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sage-600"></div>
                    </div>
                )}

                <img
                    src={piece.image}
                    alt={piece.title}
                    className={`w-full h-auto transition-all duration-300 group-hover:scale-105 ${imageLoaded ? 'opacity-100' : 'opacity-0'
                        }`}
                    onLoad={() => setImageLoaded(true)}
                />

                {/* Desktop hover overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-70 transition-all duration-300 items-center justify-center hidden md:flex">
                    <div className="text-white text-center p-6 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                        <h3 className="text-2xl font-bold mb-3">{piece.title}</h3>
                        {piece.description && (
                            <p className="text-lg mb-4 leading-relaxed">{piece.description}</p>
                        )}
                        {piece.medium && (
                            <p className="text-sm opacity-90 mb-2">Medium: {piece.medium}</p>
                        )}
                        {piece.dimensions && (
                            <p className="text-sm opacity-90 mb-6">Dimensions: {piece.dimensions}</p>
                        )}
                        <ContactButton
                            text="Inquire About Commission"
                            onClick={handleInquire}
                            className="text-sm px-6 py-3"
                        />
                    </div>
                </div>
            </div>

            {/* Mobile info section - always visible */}
            <div className="md:hidden mt-6 bg-white p-6 rounded-lg shadow-md">
                <div className="flex justify-between items-start mb-4">
                    <div className="flex-1">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">{piece.title}</h3>
                        <div className="space-y-1 text-sm text-gray-600">
                            {piece.medium && <p>Medium: {piece.medium}</p>}
                            {piece.dimensions && <p>Dimensions: {piece.dimensions}</p>}
                            {piece.year && <p>Year: {piece.year}</p>}
                        </div>
                    </div>
                    <button
                        onClick={() => setShowDetails(!showDetails)}
                        className="bg-sage-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-sage-700 transition-colors ml-4"
                    >
                        {showDetails ? 'Hide Details' : 'View Details'}
                    </button>
                </div>

                {/* Expandable description on mobile */}
                {showDetails && (
                    <div className="border-t pt-4 space-y-4">
                        {piece.description && (
                            <p className="text-gray-700 leading-relaxed">{piece.description}</p>
                        )}
                        <ContactButton
                            text="Inquire About Commission"
                            onClick={handleInquire}
                            className="w-full"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ArtPiece;